<app-classroom-select
    [filterForReservations]="true"
    (onClick)="onPlaceSelected($event)"
></app-classroom-select>
